if (process.env.NODE_ENV !== 'production') {
    require('./styles/index.scss');
}

import $ from 'jquery';
import 'bootstrap';
import CustomStyles from './js/_custom-styles';
import ScrollspyMenu from './js/_scrollspy-menu';
import Navigation from './js/_navigation';
import InteractiveMap from './js/_interactive-map';
import SocialWall from './js/_social-wall';
import Animation from './js/_animation';
import Filters from './js/_filters';
import Cookies from './js/_cookies';

//Initiliaze js scripts
$(function(){
    Cookies.initialize();
    CustomStyles.initialize();
    Navigation.initialize();
    ScrollspyMenu.initialize();
    InteractiveMap.initialize();
    SocialWall.initialize();
    Animation.initialize();
    Filters.initialize();

    //HACKS
    //hack to open all the gutenberg custom blocks links in a new tab
    $('.wp-block-respifil-useful-links, .wp-block-respifil-documents, .wp-block-respifil-private-documents, .wp-block-respifil-video-documents').attr('target', '_blank'); 
    
    //hack to remove accordion data-parent attribute to be consistent and have no automatic closing of items
    $('.wp-block-respifil-accordion, .wp-block-respifil-accordion .collapse').attr('data-parent', '');
});

//development specific code
/*if (process.env.NODE_ENV !== 'production') {
    console.log('Looks like we are in development mode!');
}
else{ //TODO: just for debug, remove for real production
    console.log('Looks like we are in production mode!');
}*/